module.exports = __webpack_public_path__ + "static/media/Rapport1.13562981.png";